// This should be replaced in production by running a gulp task to replace the values by file md5 hashes
const hashes = {
	'pt-BR.json': '#{pt-BR}',
	'pt-PT.json': '#{pt-PT}',
	'en-US.json': '#{en-US}',
};

export const langHash = (lang: string): string => {
	if (hashes[lang] && hashes[lang].indexOf('#{') !== 0) {
		return hashes[lang];
	}

	// By default, always returns the current timestamp, in the worst case scenario, we will reload the jsons always
	return new Date().getTime().toString();
};
